// extracted by mini-css-extract-plugin
module.exports = {"cont":"AuthLoginDefault_cont__3mEmx","box-form":"AuthLoginDefault_box-form__3XDiy","info":"AuthLoginDefault_info__3MXDz"};